import { render } from "./EventsHackathon.vue?vue&type=template&id=7c2d9804&scoped=true"
import script from "./EventsHackathon.vue?vue&type=script&lang=js"
export * from "./EventsHackathon.vue?vue&type=script&lang=js"

import "./EventsHackathon.vue?vue&type=style&index=0&id=7c2d9804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2d9804"]])

export default __exports__